import React from "react";
import { useSelector } from "react-redux";
import { Button } from "rhombus-react";

import { PREVIEW_2_URL, TIA_DOMAIN } from "utils/constants";
import { isLegacyPreview } from "utils/Preview";

export default function PreviewVersionsButton({ creativeId, disabled, isSocial }) {
	const creative = useSelector(state => state.creativeDetails);

	let link = `${TIA_DOMAIN}/preview/${creativeId}`;

	if(!isLegacyPreview(creative)){
		link = `${PREVIEW_2_URL}/creative-versions/${creativeId}`;
	}

	return (
		<a href={link} target="_blank">
			<Button
				key="preview"
				icon="preview"
				style="block"
				disabled={disabled}>Preview Versions
			</Button>
		</a>
	);
}
